import { GetContextMenuItemsParams } from 'ag-grid-community';
import { autoinject } from 'aurelia-framework';
import { AgGridCustomContextMenu } from '../../resources/agGrid/agGridCustomContextMenu';
import { ReportOverviewExportToExcel } from './report-overview-export-to-excel';
import { ReportingOverview } from './reporting-overview';
import { CustomerSettings } from '../../classes/customer-settings';

@autoinject()
export class ReportingOverviewContextMenu extends AgGridCustomContextMenu {
  constructor(excelExportParamsProvider: ReportOverviewExportToExcel,private customerSetting:CustomerSettings) {
    super(customerSetting);
    this.setExcelParams(excelExportParamsProvider);
  }

  override getContextMenuItems(params: GetContextMenuItemsParams, viewModel: ReportingOverview) {
    return [
      ...super.getContextMenuItems(params, viewModel),
      'separator',
      {
        name: 'Show All',
        checked: viewModel.showAll,
        action: () => {
          // set showAll Parameter in Parent ViewModel
          viewModel.showAll = !viewModel.showAll;
        }
      }
    ];
  }
}
